import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Container, Image } from 'react-bootstrap';
import i18n, { supportedLanguage } from 'I18n';
import { ReactComponent as TickIcon } from 'assets/images/tick.svg';
import { ReactComponent as LanguageIcon } from 'assets/images/language.svg';

const allLanguagesMap = {
  "en": {
    name: "English",
    value: "en",
  },
  "zh-Hant": {
    name: "繁體中文",
    value: "zh-Hant",
  },
  "zh-Hans": {
    name: "简体中文",
    value: "zh-Hans",
  }
};

const languageList = supportedLanguage.map(item => allLanguagesMap[item]);

const LanguageItem = ({
  item,
  selectedItem,
  changeLanguage,
}) => {
  return (
    <div
      key={item.value}
      className="nav_dropDownMenu_item_container"
      onClick={() => changeLanguage(item.value)}
    >
      <Container className="nav_dropDownMenu_item">
        <div className="dropDownItem_text field-text">
          {item.name}
        </div>
        {
          item.value === selectedItem.value && (
            <TickIcon className="dropDownItem_image" />
          )
        }
      </Container>
    </div>
  )
}

const LanguageDropdown = ({
  selectedItem,
  languageDropdownOpen,
  changeLanguage,
}) => {
  if (!languageDropdownOpen) {
    return null;
  };
  return (
    <div className='language-dropdown'>
      {
        languageList.map(item => (
          <LanguageItem
            item={item}
            selectedItem={selectedItem}
            changeLanguage={changeLanguage}
          />
        ))
      }
    </div>
  )
}


const SelectLanguage = ({
  language,
  languageDropdownOpen,
  setLanguageDropdownOpen,
  setSideMenuDropdownOpen,
  extraContainerClassName,
  extraSeparateLine = false,
}) => {
  const dropdownRef = useRef();
  const dispatch = useDispatch();

  const [updateLanguage, setUpdateLanguage] = useState();
  const selectedItem = useMemo(() => {
    const selected = languageList.filter(item => item.value === language)?.[0];
    return selected || {};
  }, [language]);

  const clickLanguage = () => {
    if (setSideMenuDropdownOpen && typeof setSideMenuDropdownOpen === 'function') {
      setSideMenuDropdownOpen(false);
    };
    setLanguageDropdownOpen(!languageDropdownOpen);
  }

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);

    dispatch({
      type: 'users/updateState',
      payload: { language: lang },
    });
    setLanguageDropdownOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setLanguageDropdownOpen(false);
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (i18n.language !== language) {
      setUpdateLanguage(language);
    };
  }, [language]);

  if (supportedLanguage.length <= 1) {
    return null;
  };

  return (
    <>
      {extraSeparateLine && (
        <div className="header-language-separate"> | </div>
      )}
      <div
        ref={dropdownRef}
        className={`select-language-container ${extraContainerClassName}`}
      >
        <div
          className='select-language-section'
          onClick={clickLanguage}
        >
          <div className='select-language-left'>
            <LanguageIcon
              className="language-image"
            />
            <div className='language-title'>
              {i18n.t("settings_language")}
            </div>
          </div>

          <div className='select-language-right'>
            <div className='language-active'>
              {selectedItem.name}
            </div>
            <Image
              className={`language-drop-down-image ${languageDropdownOpen ? 'language-dropdown-open' : ''}`}
              src={"/profile/right-arrow.png"}
              srcSet={'/profile/right-arrow@2x.png 2x, /profile/right-arrow@3x.png 3x'}
            />
          </div>
        </div>
        <LanguageDropdown
          selectedItem={selectedItem}
          languageDropdownOpen={languageDropdownOpen}
          changeLanguage={changeLanguage}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  language: state.users.language,
});

export default connect(mapStateToProps)(SelectLanguage);
